const SHARED = Object.freeze({
  DEFAULT_LAYOUT: 'layout',
  TODAY_END_DATE: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10) + ' 23:59:59'
})

const DATE = Object.freeze({
  SHORT: 'YYYY-MM-DD',
  LONG: 'YYYY-MM-DD HH:mm:ss',
  TIME: 'HH:mm a',
  MONTH: 'MMM YYYY'
})

const REGEX = {
  INVALID_CHARACTERS: /^[^;:：；<>《》=*]+$/,
  NOT_ALLOW_MULTIPLE_SPACE: /^\S+(?: \S+)*$/,
  EMAIL: /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
  PASSWORD: /^(?=.*\d).{6,}$/, // minimum 6 chars. minimum 1 number.
  NUMERIC: /^[\d]+$/,
  MIN_ONE_NUMERIC: /[\d]{1}/
}

const PRODUCT_CATEGORY = [
  {
    name: 'Hair',
    link: '/asd',
    subCategories: [
      { name: 'Shampoo', link: '/asd' },
      { name: 'Dry Shampoo', link: '/asd' },
      { name: 'Scalp Care', link: '/asd' },
      { name: 'Conditioner', link: '/asd' },
      { name: 'Home Care', link: '/asd' },
      { name: 'Styling', link: '/asd' }
    ]
  },
  {
    name: 'Beauty',
    link: '/asd',
    subCategories: [{ name: 'Shampoo', link: '/asd' }]
  },
  { name: 'VCare', link: '/review' },
  { name: 'Wellness', link: '/asd' },
  { name: 'Aroma Senses', link: '/asd' },
  { name: 'Health Booster', link: '/asd' },
  { name: 'Voucher', link: '/voucher' },
  { name: 'Agent Deals', link: '/asd' }
]

export { SHARED, DATE, REGEX, PRODUCT_CATEGORY }
